import { axiosSwagger } from "@/axios";

export const state = {
    pinFile: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // PIN FILE
    pinFileLoading: (state, loading) => {
        state.pinFile.loading = loading;
    },
    setPinFileData: (state, data) => {
        state.pinFile.data = data;
    },
    setPinFileTotal: (state, total) => {
        state.pinFile.total = total;
    },
    removePinFile: (state, id) => {
        state.pinFile.data = state.pinFile.data.filter(
            (el) => el.id !== id
        );
    },
}


export const actions = {
    // READ PIN FILE
    async readPinFile({ commit }) {
        commit("pinFileLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileManager/Pin/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            commit("setPinFileData", response.data);
            commit("setPinFileTotal", response.data.length);
            commit("pinFileLoading", false);

            return response;
        })
        .catch(() => {
            commit("pinFileLoading", false);
        });
    },
    // REMOVE PIN FILE
    async removePinFile({ commit }, id) {
        return await axiosSwagger
        .put(`/api/FileManager/UnPin/${id}`)
        .then((response) => {
            commit("removePinFile", id);

            return response;
        });
    },
}